<template>
  <div class="cell-wrapper" @click="$emit('click')">
    <div class="cell-title flex">
      <div class="list-left">
        <div class="avatar-box">
          <img class="session-avatar" :src="user.avatar" alt />
          <div class="unread-box">
            <span class="unread-num" v-if="user.unreadCount != 0">{{
              user.unreadCount
            }}</span>
          </div>
        </div>
      </div>
      <div class="list-right relative">
        <div class="content-top flex justify-c_space-b">
          <p class="name text-ellipsis">{{ user.name }}</p>
          <span class="time">{{ user.lastTime }}</span>
        </div>
        <div class="content-bottom flex">
          <p class="lastmsg text-ellipsis">{{ user.lastMessage }}</p>
        </div>
        <span
          class="remove-session-btn"
          @click.stop.prevent="removeConversation()"
          >删除</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cell-cell",
  props: {
    user: Object,
  },
  methods: {
    removeConversation() {
      // 停止冒泡，避免和点击会话的事件冲突
      // event.stopPropagation()
      // console.log(this.user);
      if (this.user.sessionId) {
        tim.deleteConversation(this.user.sessionId);
      }
    },
  },
};
</script>
<style scoped>
.cell-wrapper {
  width: 650px;
  background-color: #fff;
  border-bottom: 1px solid #f6f7f8;
}

.flex {
  display: flex;
  flex-flow: row nowrap;
}

.justify-c_space-b {
  justify-content: space-between;
}

.relative {
  position: relative;
}

.list-left .avatar-box {
  position: relative;
  width: 50px;
  height: 50px;
  margin: 5px 10px 0;
}

.avatar-box .unread-box {
  display: inline-block;
  position: absolute;
  top: 62%;
  right: 0;
}

.unread-box .unread-num {
  min-width: 10px;
  height: 20px;
  padding: 0 6px;
  line-height: 20px;
  text-align: center;
  color: #fff;
  background-color: #ff5722;
  border-radius: 3px;
  z-index: 2;
}

.unread-box .unread-num:empty {
  display: none;
}

.cell-wrapper .cell-title {
  height: 60px;
}

.cell-title img {
  width: 50px;
  height: 50px;
  vertical-align: middle;
  border-radius: 50%;
  object-fit: cover;
}

.content-top .name {
  display: inline-block;
  max-width: 300px;
  margin: 0;
  font-size: 16px;
  vertical-align: top;
}

.content-top .time {
  color: #51555e;
  vertical-align: top;
}

.cell-title .list-right {
  flex: auto;
}

.list-right .content-top {
  margin-top: 10px;
  margin-right: 15px;
  line-height: 20px;
}

.list-right .content-bottom {
  margin-right: 15px;
  align-items: center;
}

.list-right .remove-session-btn {
  display: none;
  position: absolute;
  top: 28px;
  right: 14px;
  cursor: pointer;
  color: #409eff;
}

.cell-wrapper:hover .remove-session-btn {
  display: inline-block;
}

.remove-session-btn:hover {
  color: #ff0000;
}

.content-bottom .lastmsg {
  max-width: 300px;
  line-height: 20px;
  color: #999;
}
</style>
